import React, { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { getWithExpiry, setWithExpiry } from "../utils";

export default function SentryErrorPage({ error, user }) {
  const [showMessage, setShowMessage] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (error?.message && chunkFailedMessage.test(error.message)) {
      if (!getWithExpiry("chunk_failed")) {
        setWithExpiry("chunk_failed", "true", 10000);
        setShowMessage(false);
        window.location.reload();
      }
    }
    setIsLoading(false);
    // Artificial loader for 5 seconds
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [error]);

  if (isLoading || showLoader) {
    // Custom loader with SVG and message
    return (
      <div className="flex flex-col justify-center h-screen items-center animate-fade-in-slow">
        <svg
          className="animate-pulse"
          fill="none"
          height="40"
          id="logo"
          viewBox="0 0 102 102"
          width="40"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M60.1689 67.1544c-6.9654-2.9925-12.9058-7.0037-22.4116-15.8665-18.114-16.796-26.9068-36.0688-19.4639-42.94508 4.6224-4.34863 18.8271-4.19583 36.7883 8.91368"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="6.36695"
            strokeLinejoin="round"
          />
          <path
            d="M67.1111 31.1001C80.7746 46.5718 88.918 63.5715 82.7293 69.8048c-2.4322 2.4322-6.4116 2.9925-11.3268 1.9674"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="6.36695"
          />
          <path
            d="M41.9653 42.9448c13.4979-18.7635 29.6127-27.1232 38.8384-22.469 9.6778 4.858 6.367 25.5569-7.3156 46.1604-13.6826 20.6035-32.7389 33.4008-42.4167 28.543-8.0032-4.0239-7.2902-19.7375.9232-36.368"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="6.36695"
          />
        </svg>
        <p
          id="loading-message"
          style={{
            fontSize: ".875rem",
            marginTop: "2rem",
            opacity: 1,
            transition: "opacity .7s ease-out",
            color: "#212130",
            fontWeight: 600,
          }}
        >
          Processing, please wait ...
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-center h-screen pl-6 pr-6 text-center animate-fade-in-slow">
      {showMessage && (
        <div>
          <p className="mb-2 font-serif text-2xl font-bold text-secondary-dark-300">
            Something went wrong
          </p>
          <p className="w-full space-y-4 font-serif text-base break-words text-secondary-dark-200">
            There was an error, please try again
            <br />
            That's all we know...
          </p>
          <div>
            <button
              onClick={() => {
                Sentry.showReportDialog({
                  user: {
                    name: `${user?.firstName || ""} ${user?.lastName || ""}`,
                    email: user?.email || "",
                  },
                  title: "Seem's like nbyula ran into issue",
                  subtitle: "Help us know the issue.",
                  subtitle2: "",
                  labelName: "Name",
                  labelEmail: "Email",
                  labelComments: "Explain ",
                  labelSubmit: "Send",
                  errorFormEntry: "All three fields are mandatory",
                  successMessage: "Thanks for reporting the issue.",
                });
              }}
              className={`focus:outline-none m-4 inline items-center rounded-md bg-secondary px-4 py-2 font-serif tracking-tight text-white transition-colors hover:bg-opacity-50 disabled:cursor-not-allowed disabled:opacity-50 sm:rounded-lg`}
            >
              Report Issue
            </button>
            <button
              onClick={() => {
                window?.location?.reload();
              }}
              className={`focus:outline-none m-4 inline items-center rounded-md bg-primary px-4 py-2 font-serif tracking-tight text-white transition-colors hover:bg-primary-dark-100 focus:bg-primary-dark-200 disabled:cursor-not-allowed disabled:opacity-50 sm:rounded-lg`}
            >
              Refresh Page
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
